module.exports = __webpack_public_path__ + "img/b_AnevilSirop_3.d85a85bf.jpeg";